import React from 'react';
import PropTypes from 'prop-types';

import ChartComponent from './ChartComponent';

const PieChartComponent = ({
  title,
  slices,
  data,
  showLegend,
  ...props
}) => {
  const dataObj = {
    datasets: [{
      data: data,
      backgroundColor: slices.map(s => s.colour),
      label: title,
      borderWidth: new Array(data.length).fill(0)
    }],
    labels: slices.map(s => s.label)
  };

  const options = {
    title: {
      display: title !== undefined,
      text: title
    },
    legend: { display: showLegend }
  };

  return (
    <ChartComponent
      type="pie"
      data={dataObj}
      options={options}
      {...props}
    />
  );
};

PieChartComponent.propTypes = {
  title: PropTypes.string,
  slices: PropTypes.arrayOf(PropTypes.shape({
    colour: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  showLegend: PropTypes.bool
};

export default PieChartComponent;


// WEBPACK FOOTER //
// src/Components/PieChartComponent.jsx